module.exports = __webpack_public_path__ + "static/media/energy_icon.11fab806.svg";